import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { useParams } from "react-router-dom";
import { formatDateonly, Get_Api } from "../Api_Url";
import ContentLoader from "react-content-loader";
import { Helmet } from "react-helmet-async";

function BlogDetils() {
  const { id } = useParams();
  const [Blogdetail, setBlogdetail] = useState({});
  const [IsUploading, setIsUploading] = useState(false);

  const GetBlog = async () => {
    try {
      setIsUploading(true);
      const response = await Get_Api(`api/admin/GetABlogDetails/${id}`);
      setBlogdetail(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (id !== null) {
      GetBlog();
    }
  }, [id]);

  return (
    <>
      <Helmet>
        <title>{Blogdetail?.MetaTitle || "Default Title"}</title>
        <meta
          name="description"
          content={Blogdetail?.MetaDescription || "Default Description"}
        />
        <meta
          name="keywords"
          content={Blogdetail?.MetaTags?.join(", ") || "Travel, Tour"}
        />
      </Helmet>
      <Navbar />
      <div className="about-div">
        <h1>Articles</h1>
        <p>
          <i>Home - Blogs</i>
        </p>
      </div>
      <>
        {IsUploading ? (
          <ContentLoader viewBox="0 0 400 475" height={"100%"} width={"100%"}>
            <circle cx="30" cy="258" r="30" />
            <rect x="75" y="233" rx="4" ry="4" width="100" height="13" />
            <rect x="75" y="260" rx="4" ry="4" width="50" height="8" />
            <rect x="0" y="210" rx="5" ry="5" width="400" height="10" />
            <rect x="0" y="0" rx="5" ry="5" width="400" height="200" />
          </ContentLoader>
        ) : (
          <div className="blog-content">
            <div className="main-content">
              <img
                src={Blogdetail?.Image}
                alt="Blog"
                className="detailblog-image"
              />
              <div className="blog-meta">
                <p>{formatDateonly(Blogdetail?.createdAt)}</p>
              </div>
              <h2>{Blogdetail?.Name}</h2>
              <div
                dangerouslySetInnerHTML={{ __html: Blogdetail?.Detail }}
                style={{ color: 'black', fontSize: '14px', lineHeight: '1.6', marginTop: '20px' }}
              ></div>
            </div>
          </div>
        )}
      </>

      <Footer />
    </>
  );
}

export default BlogDetils;
